import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusType } from '../../models/status-type.enum';

@Component({
standalone: false,
  selector: 'app-status',
  styleUrls: ['./status.component.scss'],
  templateUrl: './status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusComponent {
  @Input() public name: string;
  @Input() public tooltip: string;
  @Input() public type: StatusType = StatusType.NEUTRAL;
  @Input() public icon: string;
  @Input() public bold: boolean;
  @Input() public class: string;

  constructor() {}

}
